import { Tooltip } from 'antd';
import React, { useState } from 'react';

type TruncatedTextProps = {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

const tooltipBodyStyle: React.CSSProperties = {
  backgroundColor: 'var(--color-surface-raised, #ffffff)',
  color: 'var(--color-text-base, #2e2e2e)',
  border: '1px solid var(--color-border, #dbeae3)',
  fontSize: 13,
};

/**
 * CSS ellipsis. Measures overflow only on hover or focus, then shows a
 * tooltip. Nothing runs on mount: no effect, no observer, no DOM write.
 */
export const TruncatedText: React.FC<TruncatedTextProps> = ({
  children,
  className,
  style,
}) => {
  const [open, setOpen] = useState(false);

  const measure = (element: HTMLElement) => {
    const text =
      typeof children === 'string' || typeof children === 'number'
        ? String(children)
        : '';
    if (!text) {
      setOpen(false);
      return;
    }
    setOpen(element.scrollWidth > element.clientWidth);
  };

  return (
    <Tooltip
      title={open ? children : undefined}
      open={open}
      arrow={false}
      styles={{ body: tooltipBodyStyle }}
    >
      <span
        className={className ? `scope-truncate ${className}` : 'scope-truncate'}
        style={style}
        onPointerEnter={(event) => measure(event.currentTarget)}
        onFocus={(event) => measure(event.currentTarget)}
        onPointerLeave={() => setOpen(false)}
        onBlur={() => setOpen(false)}
      >
        {children}
      </span>
    </Tooltip>
  );
};
